<template>
  <q-page class="container flex column flex-center text-center q-px-md q-py-xl">
    <q-banner dense>
      <template
        v-if="success"
        #avatar
      >
        <q-icon
          color="positive"
          name="done"
        />
      </template>
      <b class="fs-18">{{ $t(`pages.unsubscribe.${success ? 'success' : 'invalid'}`) }}</b>
    </q-banner>
    <div class="fs-14 q-mb-lg q-mt-md text-grey-8">
      {{ $t(`pages.unsubscribe.${account ? 'change' : 'login'}`) }}
    </div>
    <q-btn
      class="q-mb-md"
      color="positive"
      :label="account ? $t('label.settings') : $t('button.log_in')"
      :to="{
        name: `account.${account ? 'settings' : 'login'}`,
      }"
      unelevated
    />
  </q-page>
</template>

<script>
import { mapGetters } from 'vuex';

const module = {
  namespaced: true,
  state: () => ({
    success: false,
  }),
  actions: {
    async unsubscribe({ commit }, params) {
      try {
        await this.$axios.post('/api/unsubscribe', params);
        commit('setSuccess', true);
      } catch (err) {
        commit('setSuccess', false);
      }
    },
  },
  mutations: {
    setSuccess(state, success) {
      state.success = success;
    },
  },
};

export default {
  name: 'UnsubscribePage',
  preFetch({ currentRoute, store }) {
    store.registerModule('unsubscribe', module);

    return store.dispatch('unsubscribe/unsubscribe', {
      unsubscription_key: currentRoute.query.unsubscription_key,
    });
  },
  computed: {
    ...mapGetters(['account']),
    success() {
      return this.$store.state.unsubscribe.success;
    },
  },
};
</script>
